const translations = {
  en: {
    withdrawUsing: 'Withdraw using',
    walletAddress: 'Wallet Address',
    currency: 'Currency',
    amount: 'Amount',
    payoutLimits: 'PayoutLimits: Minimum',
    maximum: 'Maximum',
    noLimit: 'No Limit',
    comments: 'Comments',
    back: 'BACK',
    submit: 'SUBMIT',
    warning: 'Warning',
    amountRequired: 'Amount required',
    withdrawalStatus: 'Withdrawal Status',
    amountNotPermitted: 'amount not permitted, please check your withdrawal balance',
    cashappPlaceholder: 'Must start with $ sign',
    venmoPlaceholder: 'Must start with @ sign',
    applePayPlaceholder: 'Valid phone number format +1234567890',
    emailPlaceholder: 'Valid email address',
    tyltPlaceholder: 'CPF / PIX (TaxID)',
    defaultPlaceholder: 'Enter wallet address',
  },
  es: {
    withdrawUsing: 'Retirar usando',
    walletAddress: 'Dirección de Wallet',
    currency: 'Moneda',
    amount: 'Monto',
    payoutLimits: 'Límites de retiro: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sin Límite',
    comments: 'Comentarios',
    back: 'ATRÁS',
    submit: 'ENVIAR',
    warning: 'Advertencia',
    amountRequired: 'Monto requerido',
    withdrawalStatus: 'Estado del Retiro',
    amountNotPermitted: 'Monto no permitido, por favor verifique su saldo disponible para retiro',
    cashappPlaceholder: 'Debe comenzar con signo $',
    venmoPlaceholder: 'Debe comenzar con signo @',
    applePayPlaceholder: 'Formato de teléfono válido +1234567890',
    emailPlaceholder: 'Dirección de correo válida',
    tyltPlaceholder: 'CPF / PIX (Identificación fiscal)',
    defaultPlaceholder: 'Ingrese dirección de wallet',
  },
  pt: {
    withdrawUsing: 'Sacar usando',
    walletAddress: 'Endereço da Wallet',
    currency: 'Moeda',
    amount: 'Valor',
    payoutLimits: 'Limites de saque: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sem Limite',
    comments: 'Comentários',
    back: 'VOLTAR',
    submit: 'ENVIAR',
    warning: 'Aviso',
    amountRequired: 'Valor obrigatório',
    withdrawalStatus: 'Status do Saque',
    amountNotPermitted: 'Valor não permitido, por favor verifique seu saldo disponível para saque',
    cashappPlaceholder: 'Deve começar com sinal $',
    venmoPlaceholder: 'Deve começar com sinal @',
    applePayPlaceholder: 'Formato de telefone válido +1234567890',
    emailPlaceholder: 'Endereço de e-mail válido',
    tyltPlaceholder: 'CPF / PIX (TaxID)',
    defaultPlaceholder: 'Insira o endereço da wallet',
  },
}

export default translations
